// Анімація завантаження сайту

import React from "react";
import "../styles/SplashScreen.css";
import logoUrl from "../img/logo.png";

const SplashScreen = ({ hide = false }) => {
  return (
    <div className={`splash ${hide ? "splash--hide" : ""}`}>
      {/* Фонові кулі */}
      <div className="splash__orb splash__orb--one" />
      <div className="splash__orb splash__orb--two" />

      {/* Сітка */}
      <div className="splash__grid" />

      {/* Світлові промені */}
      <div className="splash__beam splash__beam--one" />
      <div className="splash__beam splash__beam--two" />

      {/* Біжуча стрічка */}
      <div className="splash__ticker" aria-hidden="true">
        <span>
          ⚽ ФУТБОЛ • 🏆 УПЛ • 🌍 ЧЕМПІОНАТ СВІТУ • 🇺🇦 УКРАЇНА • 🎾 ТЕНІС • 🥊 БОКС •
          🏒 ХОКЕЙ • ⛷️ БІАТЛОН • 🏀 БАСКЕТБОЛ • 🥋 MMA • ⚽ ФУТБОЛ • 🏆 УПЛ •
          🌍 ЧЕМПІОНАТ СВІТУ • 🇺🇦 УКРАЇНА • 🎾 ТЕНІС • 🥊 БОКС • 🏒 ХОКЕЙ •
          ⛷️ БІАТЛОН • 🏀 БАСКЕТБОЛ • 🥋 MMA •
        </span>
      </div>

      <div className="splash__content" role="status" aria-live="polite">
        <div className="splash__logoBox">
          <div className="splash__ring" />
          <img
            src={logoUrl}
            alt="BigSPORT"
            className="splash__logo"
          />
        </div>

        <div className="splash__title">BigSPORT</div>

        <span className="splash__version">v5.4</span>

        <p className="splash__subtitle">
          Спортивні новини України та світу
        </p>

        <div className="splash__loader">
          <span />
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
